import { render, staticRenderFns } from "./SeriesCategorySelectorButton.vue?vue&type=template&id=a8b96670&"
import script from "./SeriesCategorySelectorButton.vue?vue&type=script&lang=js&"
export * from "./SeriesCategorySelectorButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports